import * as actionTypes from "../ActionTypes";

// ✅ SAVE
export const saveCoverImageRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_CARECELL_COVERIMAGE_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveCoverImageSuccess = (data) => ({
  type: actionTypes.SAVE_CARECELL_COVERIMAGE_SUCCESS,
  payload: data,
});

export const saveCoverImageFailure = (error) => ({
  type: actionTypes.SAVE_CARECELL_COVERIMAGE_FAILURE,
  payload: error,
});

// ✅ UPDATE
export const updateCoverImageRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_CARECELL_COVERIMAGE_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const updateCoverImageSuccess = (data) => ({
  type: actionTypes.UPDATE_CARECELL_COVERIMAGE_SUCCESS,
  payload: data,
});

export const updateCoverImageFailure = (error) => ({
  type: actionTypes.UPDATE_CARECELL_COVERIMAGE_FAILURE,
  payload: error,
});
export const deleteCoverImageRequest = ({ apiPayloadRequest, callback }) => {

  return {
    type: actionTypes.DELETE_CARECELL_COVERIMAGE_REQUEST,
    payload: { apiPayloadRequest, callback },
  };
};






export const deleteCoverImageSuccess = (data) => ({
  type: actionTypes.DELETE_CARECELL_COVERIMAGE_SUCCESS,
  payload: data,
});

export const deleteCoverImageFailure = (error) => ({
  type: actionTypes.DELETE_CARECELL_COVERIMAGE_FAILURE,
  payload: error,
});